import { Icon, type IconName } from '../icons/index.ts';
import type { MockWorkspace } from './types.ts';

export interface MockRailProps {
  readonly workspaces: readonly MockWorkspace[];
  readonly icons: readonly IconName[];
}

/**
 * Cỡ chữ đi theo TINT vì thiết kế cho ô workspace chính chữ to hơn hai ô kia: 14px cho ô `brand`
 * (dòng 630), 11px cho hai ô còn lại (631–632). Đây là số đo, không phải nhịp tự đặt.
 */
const WORKSPACE_TINT = {
  brand: 'rounded-tile bg-brand-600 text-body text-white',
  'brand-soft': 'rounded-pill bg-brand-50 text-micro text-brand-600',
  success: 'rounded-pill bg-success-bg text-micro text-success-fg',
} as const;

/**
 * Rail dọc 60px của mock app.
 *
 * **Ẩn hẳn dưới `lg`, không thu nhỏ** (`reference.md` §2.1): rail 60px + sidebar 232px là 292px
 * px cứng, ở màn 360px chỉ còn 68px cho khung nội dung. Không có cách co nào cứu được, nên luật
 * là bỏ chứ không phải ép.
 *
 * `w-15` = 60px (thang spacing Tailwind v4: 15 × 4px), không phải số tuỳ tiện.
 */
export function MockRail({ workspaces, icons }: MockRailProps) {
  return (
    <div className="hidden w-15 flex-col items-center gap-2.5 border-r border-ink-100 bg-surface py-3 lg:flex">
      {workspaces.map((workspace) => (
        <div
          key={workspace.label}
          className={`grid size-[34px] place-items-center font-bold ${WORKSPACE_TINT[workspace.tint]}`}
        >
          {workspace.label}
        </div>
      ))}
      <div className="my-0.5 h-px w-6 bg-ink-100" />
      <div className="mt-1 flex flex-col items-center gap-3.5 text-ink-400">
        {icons.map((name) => (
          <Icon key={name} name={name} size={19} />
        ))}
      </div>
    </div>
  );
}
